<template>
  <confirm-dialog
    :show="show"
    :message="message"
    @accept="deleteWhatsappTemplate"
    @close="$emit('close')"
  />
</template>

<script>
import ConfirmDialog from '@/components/global/ConfirmDialog';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    whatsappTemplate: {
      type: Object,
      required: true,
    },
  },
  components: {
    ConfirmDialog,
  },
  computed: {
    message() {
      return `¿Esta seguro de que desea eliminar la plantilla ${this.whatsappTemplate.name}? Esta acción no se puede deshacer.`;
    },
  },
  methods: {
    deleteWhatsappTemplate() {
      this.axios.delete(`whatsapp_templates/${this.whatsappTemplate.id}`)
        .then(() => {
          this.$emit('deleted');
          this.$emit('close');
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/WhatsappTemplates/DeleteWhatsappTemplateDialog.vue